// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-popup-company-logo[data-v-fb9969e0]{flex:none;width:48px;height:48px;border-radius:8px;border:1px solid #eceff1}", ""]);
// Exports
module.exports = exports;
